import React from "react";
import {GridFilterInputValueProps} from "@material-ui/data-grid";
import {statusMap} from "../sharedComponents/OrderStatusChip";
import {FormLabel, Select} from "@material-ui/core";

export function OrderStatusFilterInput(props: GridFilterInputValueProps) {
    const {item, applyValue} = props;
    return (<>
        <FormLabel className="MuiInputLabel-formControl MuiInputLabel-shrink">Status</FormLabel>
        <Select native value={item.value ?? '-'} onChange={(ev) => applyValue({
        ...item,
        value: ev.target.value
    })}>
        <option value="-">-</option>
        {Object.entries(statusMap).map(([name, status]) => <option value={name}>{status.name}</option>)}
    </Select>
    </>);
}
